import {ApiResult} from "../ApiResult";
import {QuizViewModel} from "./QuizViewModel";
import {QuizQuestion} from "./QuizQuestion";

export class QuizResult extends ApiResult {
  quiz!: QuizViewModel;
  constructor(data: any) {
    super(data);
    this.quiz = new QuizViewModel(data);
  }
}
